import React from 'react';
import MaterialTable from "material-table";
import {cellS,headerS,} from '../../../../St/comps/cStyle'
import { useTranslation } from "react-i18next";

export default function TrunItemsAvgTable(props){
    const { t } = useTranslation(["forms"]);

    const {data} = props;

 var columns = [
    {title: t("item-no"), field: "currency_from",},
    {title: t("item"), field: "Name_Item",},
    {title: t("incoming-amount"), field: "Income",},
    {title: t("outgoing-amount"), field: "Outcome",},
    {title: t("current-balance"), field: "Balance",},
    {title: t("stagnation-rate"), field: "Avg_rece",},
    {title: t("turnover-rate"), field: "Avg_rouran",},
  ];


    return(
        <MaterialTable style={{boxShadow:'none'}}
              options={{ 
              pageSize: 7,
              toolbar: false,
              sorting: false,
              showTitle: false,
              paging: false,
              headerStyle: headerS,
              cellStyle: cellS,
              maxBodyHeight: '70vh',
              minBodyHeight: '70vh',

             }}
       
             localization={{
               
              body:{
                emptyDataSourceMessage:<h3 
                style={{ marginTop:'20vh', border:'solid 0px', boxShadow:'none'}}
                ></h3> } }}
             columns={columns}
             data={data}            
             onRowClick={(event, rowData) => {
              event.stopPropagation();
            }}/>
    )
}